/**
 * Get element style value, e.g. width, margin-left..
 *
 */
export function getStyle(element, prop, pseudoElement = null) {
    if (!element || !prop) {
        return "";
    }
    let style = element.style[prop];
    try {
        if (document.defaultView) {
            const computedStyles = document.defaultView.getComputedStyle(element, pseudoElement);
            return style || computedStyles[prop] || "";
        }
    }
    catch (e) {
        return style;
    }
    return "";
}
//# sourceMappingURL=style.js.map